module.exports = __webpack_public_path__ + "static/media/get-storage-t4.ee20b600.nom";